module.exports = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "adcode": 410602,
        "name": "鹤山区",
        "center": [
          114.166551,
          35.936128
        ],
        "centroid": [
          114.127099,
          35.966546
        ],
        "childrenNum": 0,
        "level": "district",
        "parent": {
          "adcode": 410600
        },
        "subFeatureIndex": 0,
        "acroutes": [
          100000,
          410000,
          410600
        ]
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                114.190994,
                35.981161
              ],
              [
                114.188942,
                35.98087
              ],
              [
                114.186715,
                35.981009
              ],
              [
                114.184784,
                35.982839
              ],
              [
                114.184004,
                35.982421
              ],
              [
                114.181784,
                35.982857
              ],
              [
                114.18108,
                35.984796
              ],
              [
                114.179543,
                35.984323
              ],
              [
                114.174824,
                35.988782
              ],
              [
                114.175112,
                35.989612
              ],
              [
                114.173984,
                35.992271
              ],
              [
                114.173196,
                35.992368
              ],
              [
                114.171765,
                35.994246
              ],
              [
                114.172181,
                35.996257
              ],
              [
                114.171197,
                35.998365
              ],
              [
                114.170166,
                35.998256
              ],
              [
                114.169848,
                36.000842
              ],
              [
                114.171765,
                36.001393
              ],
              [
                114.171598,
                36.003822
              ],
              [
                114.172431,
                36.004113
              ],
              [
                114.172287,
                36.005215
              ],
              [
                114.174514,
                36.005712
              ],
              [
                114.173885,
                36.00765
              ],
              [
                114.174226,
                36.009975
              ],
              [
                114.1759,
                36.010835
              ],
              [
                114.175741,
                36.012016
              ],
              [
                114.177505,
                36.012016
              ],
              [
                114.177566,
                36.010666
              ],
              [
                114.178338,
                36.010502
              ],
              [
                114.178013,
                36.013772
              ],
              [
                114.176786,
                36.014457
              ],
              [
                114.177202,
                36.016292
              ],
              [
                114.178073,
                36.017424
              ],
              [
                114.178081,
                36.018883
              ],
              [
                114.176498,
                36.022468
              ],
              [
                114.176324,
                36.023849
              ],
              [
                114.176975,
                36.024987
              ],
              [
                114.176937,
                36.026259
              ],
              [
                114.175983,
                36.026101
              ],
              [
                114.174923,
                36.029922
              ],
              [
                114.174877,
                36.031302
              ],
              [
                114.177225,
                36.032198
              ],
              [
                114.176233,
                36.032713
              ],
              [
                114.176188,
                36.034033
              ],
              [
                114.17537,
                36.034529
              ],
              [
                114.174908,
                36.036018
              ],
              [
                114.175756,
                36.036382
              ],
              [
                114.177384,
                36.034808
              ],
              [
                114.177717,
                36.035813
              ],
              [
                114.178846,
                36.036224
              ],
              [
                114.179406,
                36.037526
              ],
              [
                114.179262,
                36.039451
              ],
              [
                114.178422,
                36.040837
              ],
              [
                114.177467,
                36.041152
              ],
              [
                114.178444,
                36.041921
              ],
              [
                114.177982,
                36.042859
              ],
              [
                114.176597,
                36.042902
              ],
              [
                114.17696,
                36.044179
              ],
              [
                114.178513,
                36.04677
              ],
              [
                114.178142,
                36.04769
              ],
              [
                114.177112,
                36.047569
              ],
              [
                114.177187,
                36.048344
              ],
              [
                114.175854,
                36.050729
              ],
              [
                114.174627,
                36.052121
              ],
              [
                114.173453,
                36.049912
              ],
              [
                114.172484,
                36.049724
              ],
              [
                114.167379,
                36.050517
              ],
              [
                114.16688,
                36.049554
              ],
              [
                114.164819,
                36.048943
              ],
              [
                114.163297,
                36.047581
              ],
              [
                114.163131,
                36.046728
              ],
              [
                114.160025,
                36.046201
              ],
              [
                114.159791,
                36.047321
              ],
              [
                114.158942,
                36.047303
              ],
              [
                114.148453,
                36.040553
              ],
              [
                114.142167,
                36.035461
              ],
              [
                114.135737,
                36.031575
              ],
              [
                114.121672,
                36.027028
              ],
              [
                114.119658,
                36.025823
              ],
              [
                114.1145,
                36.02139
              ],
              [
                114.111281,
                36.017097
              ],
              [
                114.110479,
                36.013875
              ],
              [
                114.110615,
                36.011392
              ],
              [
                114.109608,
                36.007329
              ],
              [
                114.103503,
                35.995251
              ],
              [
                114.103231,
                35.993034
              ],
              [
                114.1037,
                35.990957
              ],
              [
                114.105245,
                35.989345
              ],
              [
                114.108131,
                35.987061
              ],
              [
                114.109335,
                35.984511
              ],
              [
                114.109199,
                35.982966
              ],
              [
                114.108063,
                35.981827
              ],
              [
                114.104374,
                35.980755
              ],
              [
                114.100353,
                35.980416
              ],
              [
                114.094582,
                35.981052
              ],
              [
                114.092567,
                35.980719
              ],
              [
                114.091491,
                35.979907
              ],
              [
                114.089,
                35.976732
              ],
              [
                114.086493,
                35.975884
              ],
              [
                114.083978,
                35.974399
              ],
              [
                114.081093,
                35.976144
              ],
              [
                114.078275,
                35.976611
              ],
              [
                114.075049,
                35.976072
              ],
              [
                114.073035,
                35.974521
              ],
              [
                114.071959,
                35.971836
              ],
              [
                114.070285,
                35.966868
              ],
              [
                114.069134,
                35.964783
              ],
              [
                114.067998,
                35.964244
              ],
              [
                114.065514,
                35.964105
              ],
              [
                114.063567,
                35.965141
              ],
              [
                114.051594,
                35.970291
              ],
              [
                114.044596,
                35.972285
              ],
              [
                114.041104,
                35.972479
              ],
              [
                114.035727,
                35.972261
              ],
              [
                114.030478,
                35.971776
              ],
              [
                114.029062,
                35.971
              ],
              [
                114.028524,
                35.968316
              ],
              [
                114.029736,
                35.964426
              ],
              [
                114.030137,
                35.960063
              ],
              [
                114.029191,
                35.955493
              ],
              [
                114.028653,
                35.954403
              ],
              [
                114.028827,
                35.950481
              ],
              [
                114.029395,
                35.949269
              ],
              [
                114.030849,
                35.948172
              ],
              [
                114.033803,
                35.947336
              ],
              [
                114.037438,
                35.945736
              ],
              [
                114.038787,
                35.94433
              ],
              [
                114.039052,
                35.942584
              ],
              [
                114.03915,
                35.937401
              ],
              [
                114.04046,
                35.935662
              ],
              [
                114.047239,
                35.933085
              ],
              [
                114.049185,
                35.932485
              ],
              [
                114.05023,
                35.931764
              ],
              [
                114.052714,
                35.931085
              ],
              [
                114.055608,
                35.928187
              ],
              [
                114.057993,
                35.926871
              ],
              [
                114.059523,
                35.925701
              ],
              [
                114.066514,
                35.923616
              ],
              [
                114.071664,
                35.921021
              ],
              [
                114.081638,
                35.915097
              ],
              [
                114.083183,
                35.913454
              ],
              [
                114.082645,
                35.911623
              ],
              [
                114.093461,
                35.91155
              ],
              [
                114.123293,
                35.91383
              ],
              [
                114.137085,
                35.914115
              ],
              [
                114.140167,
                35.913909
              ],
              [
                114.142773,
                35.913302
              ],
              [
                114.146665,
                35.911889
              ],
              [
                114.149733,
                35.914588
              ],
              [
                114.151414,
                35.914952
              ],
              [
                114.157132,
                35.915346
              ],
              [
                114.158435,
                35.915813
              ],
              [
                114.159442,
                35.919166
              ],
              [
                114.160245,
                35.920263
              ],
              [
                114.161843,
                35.921488
              ],
              [
                114.167773,
                35.923998
              ],
              [
                114.17081,
                35.925507
              ],
              [
                114.175029,
                35.929133
              ],
              [
                114.182769,
                35.932036
              ],
              [
                114.186033,
                35.934279
              ],
              [
                114.199507,
                35.944711
              ],
              [
                114.205013,
                35.946118
              ],
              [
                114.204717,
                35.947948
              ],
              [
                114.204316,
                35.953433
              ],
              [
                114.204717,
                35.961632
              ],
              [
                114.204505,
                35.965214
              ],
              [
                114.203809,
                35.968092
              ],
              [
                114.201908,
                35.971758
              ],
              [
                114.197136,
                35.976053
              ],
              [
                114.193539,
                35.978604
              ],
              [
                114.190994,
                35.981161
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "adcode": 410603,
        "name": "山城区",
        "center": [
          114.184202,
          35.896058
        ],
        "centroid": [
          114.223534,
          35.914795
        ],
        "childrenNum": 0,
        "level": "district",
        "parent": {
          "adcode": 410600
        },
        "subFeatureIndex": 1,
        "acroutes": [
          100000,
          410000,
          410600
        ]
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                114.230165,
                35.848553
              ],
              [
                114.234459,
                35.855969
              ],
              [
                114.238208,
                35.860125
              ],
              [
                114.241094,
                35.8618
              ],
              [
                114.24304,
                35.86328
              ],
              [
                114.24404,
                35.865088
              ],
              [
                114.244373,
                35.867103
              ],
              [
                114.24404,
                35.86979
              ],
              [
                114.244312,
                35.871871
              ],
              [
                114.245918,
                35.874152
              ],
              [
                114.250879,
                35.876767
              ],
              [
                114.262754,
                35.878114
              ],
              [
                114.269661,
                35.879994
              ],
              [
                114.27463,
                35.882245
              ],
              [
                114.278523,
                35.885338
              ],
              [
                114.280999,
                35.887552
              ],
              [
                114.281537,
                35.889232
              ],
              [
                114.281469,
                35.891246
              ],
              [
                114.28087,
                35.89232
              ],
              [
                114.273085,
                35.897147
              ],
              [
                114.27107,
                35.898839
              ],
              [
                114.270775,
                35.899864
              ],
              [
                114.272183,
                35.909628
              ],
              [
                114.27438,
                35.913818
              ],
              [
                114.276417,
                35.914527
              ],
              [
                114.276849,
                35.915819
              ],
              [
                114.276341,
                35.921112
              ],
              [
                114.277212,
                35.924464
              ],
              [
                114.279636,
                35.926283
              ],
              [
                114.28262,
                35.926605
              ],
              [
                114.289232,
                35.928393
              ],
              [
                114.290186,
                35.928878
              ],
              [
                114.291224,
                35.927411
              ],
              [
                114.293268,
                35.926374
              ],
              [
                114.295442,
                35.92612
              ],
              [
                114.295594,
                35.924634
              ],
              [
                114.297245,
                35.924477
              ],
              [
                114.299736,
                35.92558
              ],
              [
                114.298782,
                35.926829
              ],
              [
                114.298956,
                35.927411
              ],
              [
                114.300789,
                35.929054
              ],
              [
                114.301645,
                35.930254
              ],
              [
                114.30297,
                35.930588
              ],
              [
                114.300645,
                35.933528
              ],
              [
                114.298896,
                35.933443
              ],
              [
                114.29704,
                35.936292
              ],
              [
                114.29726,
                35.937419
              ],
              [
                114.295813,
                35.937262
              ],
              [
                114.293602,
                35.938298
              ],
              [
                114.294003,
                35.940159
              ],
              [
                114.296692,
                35.940565
              ],
              [
                114.30166,
                35.94336
              ],
              [
                114.302667,
                35.944802
              ],
              [
                114.306606,
                35.948566
              ],
              [
                114.309294,
                35.952736
              ],
              [
                114.309423,
                35.955421
              ],
              [
                114.308628,
                35.956893
              ],
              [
                114.305258,
                35.958633
              ],
              [
                114.303311,
                35.958833
              ],
              [
                114.298403,
                35.958354
              ],
              [
                114.296927,
                35.957899
              ],
              [
                114.293405,
                35.954978
              ],
              [
                114.288096,
                35.95299
              ],
              [
                114.287157,
                35.951918
              ],
              [
                114.285884,
                35.948184
              ],
              [
                114.284703,
                35.946978
              ],
              [
                114.283695,
                35.946639
              ],
              [
                114.280446,
                35.946942
              ],
              [
                114.279969,
                35.947378
              ],
              [
                114.27984,
                35.951269
              ],
              [
                114.281151,
                35.959124
              ],
              [
                114.281082,
                35.965886
              ],
              [
                114.280545,
                35.970352
              ],
              [
                114.279946,
                35.972836
              ],
              [
                114.279234,
                35.973369
              ],
              [
                114.277591,
                35.973436
              ],
              [
                114.274403,
                35.972661
              ],
              [
                114.270479,
                35.971418
              ],
              [
                114.266549,
                35.970709
              ],
              [
                114.260543,
                35.970643
              ],
              [
                114.251424,
                35.971915
              ],
              [
                114.245797,
                35.974266
              ],
              [
                114.244494,
                35.972121
              ],
              [
                114.243805,
                35.973485
              ],
              [
                114.242078,
                35.973412
              ],
              [
                114.241722,
                35.975557
              ],
              [
                114.240291,
                35.975532
              ],
              [
                114.239912,
                35.974163
              ],
              [
                114.239314,
                35.975266
              ],
              [
                114.238458,
                35.975266
              ],
              [
                114.237655,
                35.973563
              ],
              [
                114.237155,
                35.973666
              ],
              [
                114.236209,
                35.97798
              ],
              [
                114.233437,
                35.97778
              ],
              [
                114.233906,
                35.97924
              ],
              [
                114.22937,
                35.979592
              ],
              [
                114.228885,
                35.981282
              ],
              [
                114.227544,
                35.981397
              ],
              [
                114.226863,
                35.982548
              ],
              [
                114.225378,
                35.98256
              ],
              [
                114.224523,
                35.980949
              ],
              [
                114.223591,
                35.981718
              ],
              [
                114.224257,
                35.987243
              ],
              [
                114.223288,
                35.987455
              ],
              [
                114.222637,
                35.986625
              ],
              [
                114.220849,
                35.986316
              ],
              [
                114.220501,
                35.986958
              ],
              [
                114.22172,
                35.987304
              ],
              [
                114.221417,
                35.989327
              ],
              [
                114.220584,
                35.988746
              ],
              [
                114.219691,
                35.989969
              ],
              [
                114.219744,
                35.992477
              ],
              [
                114.218236,
                35.991272
              ],
              [
                114.218312,
                35.992677
              ],
              [
                114.216525,
                35.993943
              ],
              [
                114.217343,
                35.996572
              ],
              [
                114.218009,
                35.997632
              ],
              [
                114.216479,
                35.997783
              ],
              [
                114.21398,
                35.996554
              ],
              [
                114.213306,
                35.99527
              ],
              [
                114.209648,
                35.993301
              ],
              [
                114.208163,
                35.992925
              ],
              [
                114.207686,
                35.990375
              ],
              [
                114.205831,
                35.989588
              ],
              [
                114.205066,
                35.988679
              ],
              [
                114.203922,
                35.99009
              ],
              [
                114.202385,
                35.990193
              ],
              [
                114.202067,
                35.99195
              ],
              [
                114.20134,
                35.991823
              ],
              [
                114.198999,
                35.989969
              ],
              [
                114.19753,
                35.990109
              ],
              [
                114.197613,
                35.98857
              ],
              [
                114.197114,
                35.987564
              ],
              [
                114.195349,
                35.986032
              ],
              [
                114.196311,
                35.985474
              ],
              [
                114.195,
                35.983911
              ],
              [
                114.192562,
                35.983766
              ],
              [
                114.192319,
                35.982276
              ],
              [
                114.190994,
                35.981161
              ],
              [
                114.193539,
                35.978604
              ],
              [
                114.197136,
                35.976053
              ],
              [
                114.201908,
                35.971758
              ],
              [
                114.203809,
                35.968092
              ],
              [
                114.204505,
                35.965214
              ],
              [
                114.204717,
                35.961632
              ],
              [
                114.204316,
                35.953433
              ],
              [
                114.204717,
                35.947948
              ],
              [
                114.205013,
                35.946118
              ],
              [
                114.199507,
                35.944711
              ],
              [
                114.186033,
                35.934279
              ],
              [
                114.182769,
                35.932036
              ],
              [
                114.175029,
                35.929133
              ],
              [
                114.17081,
                35.925507
              ],
              [
                114.167773,
                35.923998
              ],
              [
                114.161843,
                35.921488
              ],
              [
                114.160245,
                35.920263
              ],
              [
                114.159442,
                35.919166
              ],
              [
                114.158435,
                35.915813
              ],
              [
                114.157132,
                35.915346
              ],
              [
                114.151414,
                35.914952
              ],
              [
                114.149733,
                35.914588
              ],
              [
                114.146665,
                35.911889
              ],
              [
                114.146378,
                35.909628
              ],
              [
                114.147779,
                35.906474
              ],
              [
                114.154269,
                35.895122
              ],
              [
                114.154875,
                35.89218
              ],
              [
                114.154163,
                35.889299
              ],
              [
                114.152331,
                35.883828
              ],
              [
                114.153232,
                35.882421
              ],
              [
                114.155004,
                35.881814
              ],
              [
                114.163434,
                35.879412
              ],
              [
                114.164638,
                35.878587
              ],
              [
                114.166365,
                35.868437
              ],
              [
                114.162335,
                35.866132
              ],
              [
                114.163305,
                35.864585
              ],
              [
                114.166849,
                35.865689
              ],
              [
                114.169924,
                35.863559
              ],
              [
                114.17103,
                35.862315
              ],
              [
                114.176218,
                35.858748
              ],
              [
                114.178149,
                35.856897
              ],
              [
                114.17905,
                35.855501
              ],
              [
                114.184874,
                35.844384
              ],
              [
                114.186382,
                35.843037
              ],
              [
                114.187715,
                35.842466
              ],
              [
                114.190827,
                35.84229
              ],
              [
                114.211943,
                35.844554
              ],
              [
                114.213685,
                35.845598
              ],
              [
                114.215926,
                35.847406
              ],
              [
                114.217131,
                35.847874
              ],
              [
                114.220274,
                35.848134
              ],
              [
                114.230165,
                35.848553
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "adcode": 410611,
        "name": "淇滨区",
        "center": [
          114.293917,
          35.748382
        ],
        "centroid": [
          114.226508,
          35.787133
        ],
        "childrenNum": 0,
        "level": "district",
        "parent": {
          "adcode": 410600
        },
        "subFeatureIndex": 2,
        "acroutes": [
          100000,
          410000,
          410600
        ]
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                114.230165,
                35.848553
              ],
              [
                114.220274,
                35.848134
              ],
              [
                114.217131,
                35.847874
              ],
              [
                114.215926,
                35.847406
              ],
              [
                114.213685,
                35.845598
              ],
              [
                114.211943,
                35.844554
              ],
              [
                114.190827,
                35.84229
              ],
              [
                114.187715,
                35.842466
              ],
              [
                114.186382,
                35.843037
              ],
              [
                114.184874,
                35.844384
              ],
              [
                114.17905,
                35.855501
              ],
              [
                114.178149,
                35.856897
              ],
              [
                114.176218,
                35.858748
              ],
              [
                114.17103,
                35.862315
              ],
              [
                114.169924,
                35.863559
              ],
              [
                114.166849,
                35.865689
              ],
              [
                114.163305,
                35.864585
              ],
              [
                114.162335,
                35.866132
              ],
              [
                114.166365,
                35.868437
              ],
              [
                114.164638,
                35.878587
              ],
              [
                114.163434,
                35.879412
              ],
              [
                114.155004,
                35.881814
              ],
              [
                114.153232,
                35.882421
              ],
              [
                114.152331,
                35.883828
              ],
              [
                114.154163,
                35.889299
              ],
              [
                114.154875,
                35.89218
              ],
              [
                114.154269,
                35.895122
              ],
              [
                114.147779,
                35.906474
              ],
              [
                114.146378,
                35.909628
              ],
              [
                114.146665,
                35.911889
              ],
              [
                114.142773,
                35.913302
              ],
              [
                114.140167,
                35.913909
              ],
              [
                114.137085,
                35.914115
              ],
              [
                114.123293,
                35.91383
              ],
              [
                114.093461,
                35.91155
              ],
              [
                114.082645,
                35.911623
              ],
              [
                114.079389,
                35.90833
              ],
              [
                114.075663,
                35.905274
              ],
              [
                114.07489,
                35.904364
              ],
              [
                114.07492,
                35.89389
              ],
              [
                114.074314,
                35.888856
              ],
              [
                114.074655,
                35.883755
              ],
              [
                114.07514,
                35.88094
              ],
              [
                114.071967,
                35.874826
              ],
              [
                114.070285,
                35.873212
              ],
              [
                114.068945,
                35.872939
              ],
              [
                114.065113,
                35.873066
              ],
              [
                114.061553,
                35.872326
              ],
              [
                114.056713,
                35.87027
              ],
              [
                114.052745,
                35.867442
              ],
              [
                114.048776,
                35.863942
              ],
              [
                114.044542,
                35.861581
              ],
              [
                114.03862,
                35.859488
              ],
              [
                114.022132,
                35.858972
              ],
              [
                114.019981,
                35.858626
              ],
              [
                114.017497,
                35.856539
              ],
              [
                114.013998,
                35.85257
              ],
              [
                114.013256,
                35.85055
              ],
              [
                114.013385,
                35.848341
              ],
              [
                114.015005,
                35.844985
              ],
              [
                114.016755,
                35.843176
              ],
              [
                114.02086,
                35.839802
              ],
              [
                114.022609,
                35.836452
              ],
              [
                114.025631,
                35.829411
              ],
              [
                114.027047,
                35.828209
              ],
              [
                114.030077,
                35.82694
              ],
              [
                114.034106,
                35.825744
              ],
              [
                114.035924,
                35.824536
              ],
              [
                114.036393,
                35.823401
              ],
              [
                114.036537,
                35.821052
              ],
              [
                114.035651,
                35.818429
              ],
              [
                114.031554,
                35.814186
              ],
              [
                114.028327,
                35.811867
              ],
              [
                114.025495,
                35.809438
              ],
              [
                114.022533,
                35.804265
              ],
              [
                114.022064,
                35.801441
              ],
              [
                114.022397,
                35.798423
              ],
              [
                114.023404,
                35.797415
              ],
              [
                114.025154,
                35.797088
              ],
              [
                114.027646,
                35.798102
              ],
              [
                114.033636,
                35.801138
              ],
              [
                114.037135,
                35.803293
              ],
              [
                114.040233,
                35.803305
              ],
              [
                114.042914,
                35.801296
              ],
              [
                114.046012,
                35.79815
              ],
              [
                114.048163,
                35.797379
              ],
              [
                114.051389,
                35.797525
              ],
              [
                114.054759,
                35.798873
              ],
              [
                114.061008,
                35.802777
              ],
              [
                114.065643,
                35.804666
              ],
              [
                114.069134,
                35.805279
              ],
              [
                114.071686,
                35.805279
              ],
              [
                114.074845,
                35.804684
              ],
              [
                114.078132,
                35.803008
              ],
              [
                114.080487,
                35.803718
              ],
              [
                114.085319,
                35.803785
              ],
              [
                114.08881,
                35.804866
              ],
              [
                114.09284,
                35.807082
              ],
              [
                114.095718,
                35.807349
              ],
              [
                114.100277,
                35.807289
              ],
              [
                114.104503,
                35.806092
              ],
              [
                114.107123,
                35.805892
              ],
              [
                114.11013,
                35.806092
              ],
              [
                114.113955,
                35.8067
              ],
              [
                114.115629,
                35.806293
              ],
              [
                114.12012,
                35.803639
              ],
              [
                114.121665,
                35.80367
              ],
              [
                114.123839,
                35.804575
              ],
              [
                114.12705,
                35.805042
              ],
              [
                114.128792,
                35.80466
              ],
              [
                114.133048,
                35.801563
              ],
              [
                114.135525,
                35.799012
              ],
              [
                114.137062,
                35.798502
              ],
              [
                114.139842,
                35.798266
              ],
              [
                114.143325,
                35.79883
              ],
              [
                114.146203,
                35.799012
              ],
              [
                114.148044,
                35.798806
              ],
              [
                114.151225,
                35.797428
              ],
              [
                114.154065,
                35.797689
              ],
              [
                114.157746,
                35.799899
              ],
              [
                114.159321,
                35.800197
              ],
              [
                114.162631,
                35.800294
              ],
              [
                114.165547,
                35.800069
              ],
              [
                114.171901,
                35.798345
              ],
              [
                114.178248,
                35.796219
              ],
              [
                114.183004,
                35.794027
              ],
              [
                114.184943,
                35.793723
              ],
              [
                114.188389,
                35.793717
              ],
              [
                114.190297,
                35.794337
              ],
              [
                114.193743,
                35.796511
              ],
              [
                114.196614,
                35.798083
              ],
              [
                114.19856,
                35.798314
              ],
              [
                114.200325,
                35.798077
              ],
              [
                114.205922,
                35.795922
              ],
              [
                114.208224,
                35.79461
              ],
              [
                114.210095,
                35.791136
              ],
              [
                114.214427,
                35.780933
              ],
              [
                114.216161,
                35.777611
              ],
              [
                114.217403,
                35.776402
              ],
              [
                114.221978,
                35.773371
              ],
              [
                114.222818,
                35.772436
              ],
              [
                114.222924,
                35.769817
              ],
              [
                114.22088,
                35.762582
              ],
              [
                114.22091,
                35.760505
              ],
              [
                114.222447,
                35.756307
              ],
              [
                114.223591,
                35.755031
              ],
              [
                114.225462,
                35.754119
              ],
              [
                114.228203,
                35.753718
              ],
              [
                114.230119,
                35.754083
              ],
              [
                114.233066,
                35.756161
              ],
              [
                114.237254,
                35.760067
              ],
              [
                114.238693,
                35.760438
              ],
              [
                114.240935,
                35.759964
              ],
              [
                114.243654,
                35.757479
              ],
              [
                114.244524,
                35.757042
              ],
              [
                114.24794,
                35.756307
              ],
              [
                114.250152,
                35.753099
              ],
              [
                114.254075,
                35.751768
              ],
              [
                114.255294,
                35.75113
              ],
              [
                114.256673,
                35.749356
              ],
              [
                114.256218,
                35.744282
              ],
              [
                114.256377,
                35.742994
              ],
              [
                114.255287,
                35.742994
              ],
              [
                114.255249,
                35.7419
              ],
              [
                114.252303,
                35.742447
              ],
              [
                114.25437,
                35.741614
              ],
              [
                114.253961,
                35.740922
              ],
              [
                114.251114,
                35.74139
              ],
              [
                114.249175,
                35.738473
              ],
              [
                114.248266,
                35.739591
              ],
              [
                114.246478,
                35.740344
              ],
              [
                114.247031,
                35.742125
              ],
              [
                114.245827,
                35.740752
              ],
              [
                114.244441,
                35.741882
              ],
              [
                114.243601,
                35.740113
              ],
              [
                114.243813,
                35.73823
              ],
              [
                114.244782,
                35.737233
              ],
              [
                114.244684,
                35.736182
              ],
              [
                114.248508,
                35.736072
              ],
              [
                114.249432,
                35.733003
              ],
              [
                114.250288,
                35.732906
              ],
              [
                114.249137,
                35.725753
              ],
              [
                114.253583,
                35.724543
              ],
              [
                114.253484,
                35.722203
              ],
              [
                114.257892,
                35.722398
              ],
              [
                114.259785,
                35.726634
              ],
              [
                114.26358,
                35.725911
              ],
              [
                114.263368,
                35.72402
              ],
              [
                114.262057,
                35.721346
              ],
              [
                114.260709,
                35.721145
              ],
              [
                114.260073,
                35.721948
              ],
              [
                114.257354,
                35.720848
              ],
              [
                114.254582,
                35.713979
              ],
              [
                114.257809,
                35.713341
              ],
              [
                114.257619,
                35.711006
              ],
              [
                114.258536,
                35.709967
              ],
              [
                114.259051,
                35.710891
              ],
              [
                114.26333,
                35.710386
              ],
              [
                114.267397,
                35.711426
              ],
              [
                114.267904,
                35.708757
              ],
              [
                114.267261,
                35.706538
              ],
              [
                114.26589,
                35.704605
              ],
              [
                114.264171,
                35.703614
              ],
              [
                114.262345,
                35.703754
              ],
              [
                114.259217,
                35.703054
              ],
              [
                114.256907,
                35.701565
              ],
              [
                114.255256,
                35.697352
              ],
              [
                114.254825,
                35.695631
              ],
              [
                114.254294,
                35.691581
              ],
              [
                114.254105,
                35.68817
              ],
              [
                114.254438,
                35.686753
              ],
              [
                114.255415,
                35.685586
              ],
              [
                114.257324,
                35.684284
              ],
              [
                114.260596,
                35.682782
              ],
              [
                114.263716,
                35.682259
              ],
              [
                114.267738,
                35.680508
              ],
              [
                114.273691,
                35.677194
              ],
              [
                114.276478,
                35.672778
              ],
              [
                114.277652,
                35.67012
              ],
              [
                114.278144,
                35.664877
              ],
              [
                114.279234,
                35.662523
              ],
              [
                114.280787,
                35.661848
              ],
              [
                114.283082,
                35.661495
              ],
              [
                114.284279,
                35.662365
              ],
              [
                114.285748,
                35.662219
              ],
              [
                114.288088,
                35.661009
              ],
              [
                114.290239,
                35.660224
              ],
              [
                114.291867,
                35.659245
              ],
              [
                114.295828,
                35.659093
              ],
              [
                114.296836,
                35.657712
              ],
              [
                114.296518,
                35.6561
              ],
              [
                114.312627,
                35.657499
              ],
              [
                114.316716,
                35.658551
              ],
              [
                114.321541,
                35.658095
              ],
              [
                114.321405,
                35.65464
              ],
              [
                114.318398,
                35.655212
              ],
              [
                114.317587,
                35.650454
              ],
              [
                114.319784,
                35.649736
              ],
              [
                114.320102,
                35.647753
              ],
              [
                114.321465,
                35.646402
              ],
              [
                114.322003,
                35.644918
              ],
              [
                114.323601,
                35.64437
              ],
              [
                114.325812,
                35.644553
              ],
              [
                114.328713,
                35.645885
              ],
              [
                114.33172,
                35.645313
              ],
              [
                114.333182,
                35.641487
              ],
              [
                114.336643,
                35.642223
              ],
              [
                114.348367,
                35.640531
              ],
              [
                114.354729,
                35.640921
              ],
              [
                114.355706,
                35.648647
              ],
              [
                114.359288,
                35.652346
              ],
              [
                114.35794,
                35.653861
              ],
              [
                114.358455,
                35.656106
              ],
              [
                114.359977,
                35.656483
              ],
              [
                114.362363,
                35.657651
              ],
              [
                114.362991,
                35.658673
              ],
              [
                114.362302,
                35.661459
              ],
              [
                114.362348,
                35.66582
              ],
              [
                114.364817,
                35.670601
              ],
              [
                114.369565,
                35.680715
              ],
              [
                114.369914,
                35.683165
              ],
              [
                114.36874,
                35.701036
              ],
              [
                114.367892,
                35.703632
              ],
              [
                114.360992,
                35.716435
              ],
              [
                114.355122,
                35.728427
              ],
              [
                114.379313,
                35.736291
              ],
              [
                114.38441,
                35.737847
              ],
              [
                114.391347,
                35.74035
              ],
              [
                114.393968,
                35.74156
              ],
              [
                114.394778,
                35.743267
              ],
              [
                114.394914,
                35.745254
              ],
              [
                114.394021,
                35.746555
              ],
              [
                114.39143,
                35.747733
              ],
              [
                114.389075,
                35.749496
              ],
              [
                114.387878,
                35.75144
              ],
              [
                114.384834,
                35.759132
              ],
              [
                114.384432,
                35.761726
              ],
              [
                114.383804,
                35.768068
              ],
              [
                114.385425,
                35.775752
              ],
              [
                114.38725,
                35.781783
              ],
              [
                114.40882,
                35.820676
              ],
              [
                114.4042,
                35.81982
              ],
              [
                114.400852,
                35.818174
              ],
              [
                114.396823,
                35.816796
              ],
              [
                114.386455,
                35.816966
              ],
              [
                114.374367,
                35.817494
              ],
              [
                114.370209,
                35.81829
              ],
              [
                114.367922,
                35.818958
              ],
              [
                114.364695,
                35.818951
              ],
              [
                114.359046,
                35.817871
              ],
              [
                114.350381,
                35.816007
              ],
              [
                114.346072,
                35.814459
              ],
              [
                114.343929,
                35.813178
              ],
              [
                114.338415,
                35.808199
              ],
              [
                114.332969,
                35.804629
              ],
              [
                114.328372,
                35.802134
              ],
              [
                114.324676,
                35.80149
              ],
              [
                114.318989,
                35.799772
              ],
              [
                114.311763,
                35.798436
              ],
              [
                114.30528,
                35.796747
              ],
              [
                114.304341,
                35.792721
              ],
              [
                114.294609,
                35.794337
              ],
              [
                114.293821,
                35.793857
              ],
              [
                114.290633,
                35.790432
              ],
              [
                114.284316,
                35.783296
              ],
              [
                114.277773,
                35.773584
              ],
              [
                114.274349,
                35.768262
              ],
              [
                114.271827,
                35.762789
              ],
              [
                114.270396,
                35.760699
              ],
              [
                114.266882,
                35.761708
              ],
              [
                114.259664,
                35.763463
              ],
              [
                114.259922,
                35.764466
              ],
              [
                114.258165,
                35.765037
              ],
              [
                114.257831,
                35.76695
              ],
              [
                114.255234,
                35.767351
              ],
              [
                114.254847,
                35.771998
              ],
              [
                114.255688,
                35.77444
              ],
              [
                114.257945,
                35.77359
              ],
              [
                114.26336,
                35.774391
              ],
              [
                114.263148,
                35.776991
              ],
              [
                114.26205,
                35.777623
              ],
              [
                114.260656,
                35.780204
              ],
              [
                114.259051,
                35.781893
              ],
              [
                114.259036,
                35.784668
              ],
              [
                114.255279,
                35.784456
              ],
              [
                114.254385,
                35.786047
              ],
              [
                114.253196,
                35.786229
              ],
              [
                114.252992,
                35.787626
              ],
              [
                114.253757,
                35.789284
              ],
              [
                114.253567,
                35.790116
              ],
              [
                114.251712,
                35.791009
              ],
              [
                114.251772,
                35.793098
              ],
              [
                114.249061,
                35.793681
              ],
              [
                114.247675,
                35.793377
              ],
              [
                114.245668,
                35.79362
              ],
              [
                114.243199,
                35.793074
              ],
              [
                114.243449,
                35.794792
              ],
              [
                114.242873,
                35.795314
              ],
              [
                114.242624,
                35.797446
              ],
              [
                114.242563,
                35.801132
              ],
              [
                114.2412,
                35.802395
              ],
              [
                114.241684,
                35.803293
              ],
              [
                114.241775,
                35.806536
              ],
              [
                114.238965,
                35.809225
              ],
              [
                114.237678,
                35.808989
              ],
              [
                114.236731,
                35.809729
              ],
              [
                114.235133,
                35.815655
              ],
              [
                114.234633,
                35.816827
              ],
              [
                114.234179,
                35.820226
              ],
              [
                114.235194,
                35.820943
              ],
              [
                114.234694,
                35.823468
              ],
              [
                114.233687,
                35.82501
              ],
              [
                114.234035,
                35.827128
              ],
              [
                114.233119,
                35.827742
              ],
              [
                114.229233,
                35.84104
              ],
              [
                114.229029,
                35.843589
              ],
              [
                114.230165,
                35.848553
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "adcode": 410621,
        "name": "浚县",
        "center": [
          114.550162,
          35.671282
        ],
        "centroid": [
          114.482398,
          35.671496
        ],
        "childrenNum": 0,
        "level": "district",
        "parent": {
          "adcode": 410600
        },
        "subFeatureIndex": 3,
        "acroutes": [
          100000,
          410000,
          410600
        ]
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                114.289891,
                35.50179
              ],
              [
                114.288785,
                35.496652
              ],
              [
                114.285733,
                35.493275
              ],
              [
                114.283718,
                35.492202
              ],
              [
                114.278477,
                35.491056
              ],
              [
                114.275796,
                35.490178
              ],
              [
                114.274637,
                35.485759
              ],
              [
                114.27647,
                35.483119
              ],
              [
                114.27566,
                35.480674
              ],
              [
                114.273781,
                35.478522
              ],
              [
                114.27257,
                35.476175
              ],
              [
                114.272236,
                35.473486
              ],
              [
                114.272433,
                35.470328
              ],
              [
                114.273107,
                35.467846
              ],
              [
                114.275455,
                35.465364
              ],
              [
                114.280287,
                35.462346
              ],
              [
                114.284915,
                35.460608
              ],
              [
                114.28855,
                35.460138
              ],
              [
                114.293178,
                35.460181
              ],
              [
                114.294995,
                35.459846
              ],
              [
                114.298017,
                35.458705
              ],
              [
                114.301047,
                35.455284
              ],
              [
                114.306757,
                35.450527
              ],
              [
                114.312392,
                35.446978
              ],
              [
                114.317633,
                35.445306
              ],
              [
                114.324025,
                35.444514
              ],
              [
                114.327047,
                35.444654
              ],
              [
                114.329198,
                35.445264
              ],
              [
                114.339445,
                35.450668
              ],
              [
                114.340217,
                35.451198
              ],
              [
                114.341051,
                35.452833
              ],
              [
                114.339968,
                35.4559
              ],
              [
                114.341573,
                35.459956
              ],
              [
                114.342573,
                35.460541
              ],
              [
                114.343694,
                35.462145
              ],
              [
                114.348215,
                35.463242
              ],
              [
                114.350525,
                35.464169
              ],
              [
                114.351025,
                35.466072
              ],
              [
                114.353441,
                35.466401
              ],
              [
                114.354214,
                35.467346
              ],
              [
                114.35716,
                35.467419
              ],
              [
                114.357955,
                35.468462
              ],
              [
                114.360432,
                35.468779
              ],
              [
                114.362007,
                35.46859
              ],
              [
                114.362863,
                35.467742
              ],
              [
                114.362946,
                35.465419
              ],
              [
                114.363347,
                35.46484
              ],
              [
                114.368384,
                35.464218
              ],
              [
                114.369641,
                35.461895
              ],
              [
                114.372905,
                35.462828
              ],
              [
                114.377722,
                35.462639
              ],
              [
                114.378949,
                35.463126
              ],
              [
                114.380797,
                35.465864
              ],
              [
                114.382024,
                35.466547
              ],
              [
                114.38263,
                35.468938
              ],
              [
                114.384251,
                35.472633
              ],
              [
                114.384652,
                35.475334
              ],
              [
                114.385826,
                35.475327
              ],
              [
                114.38706,
                35.474584
              ],
              [
                114.38778,
                35.47587
              ],
              [
                114.387727,
                35.477315
              ],
              [
                114.393369,
                35.478284
              ],
              [
                114.395043,
                35.478193
              ],
              [
                114.395906,
                35.477132
              ],
              [
                114.397823,
                35.476315
              ],
              [
                114.397005,
                35.474681
              ],
              [
                114.397255,
                35.474071
              ],
              [
                114.404374,
                35.471566
              ],
              [
                114.406381,
                35.473553
              ],
              [
                114.406994,
                35.473504
              ],
              [
                114.407327,
                35.471712
              ],
              [
                114.409698,
                35.4692
              ],
              [
                114.410448,
                35.46937
              ],
              [
                114.410781,
                35.470889
              ],
              [
                114.413318,
                35.470523
              ],
              [
                114.414697,
                35.471163
              ],
              [
                114.416113,
                35.472931
              ],
              [
                114.417734,
                35.47312
              ],
              [
                114.419074,
                35.474163
              ],
              [
                114.418324,
                35.475242
              ],
              [
                114.417575,
                35.478455
              ],
              [
                114.418923,
                35.482107
              ],
              [
                114.420521,
                35.482857
              ],
              [
                114.4204,
                35.483771
              ],
              [
                114.417226,
                35.486112
              ],
              [
                114.413871,
                35.488173
              ],
              [
                114.412909,
                35.487752
              ],
              [
                114.410455,
                35.489197
              ],
              [
                114.409244,
                35.489148
              ],
              [
                114.408789,
                35.491105
              ],
              [
                114.407896,
                35.491568
              ],
              [
                114.407782,
                35.493086
              ],
              [
                114.40704,
                35.493708
              ],
              [
                114.40551,
                35.493647
              ],
              [
                114.403374,
                35.495213
              ],
              [
                114.40395,
                35.497109
              ],
              [
                114.398027,
                35.504258
              ],
              [
                114.39502,
                35.508866
              ],
              [
                114.394937,
                35.510932
              ],
              [
                114.396217,
                35.513327
              ],
              [
                114.398837,
                35.520981
              ],
              [
                114.402261,
                35.52602
              ],
              [
                114.405283,
                35.527836
              ],
              [
                114.4091,
                35.528841
              ],
              [
                114.412856,
                35.531022
              ],
              [
                114.416878,
                35.533843
              ],
              [
                114.4199,
                35.536731
              ],
              [
                114.422778,
                35.541495
              ],
              [
                114.426201,
                35.544242
              ],
              [
                114.430753,
                35.54632
              ],
              [
                114.43538,
                35.54766
              ],
              [
                114.441666,
                35.551613
              ],
              [
                114.455534,
                35.557667
              ],
              [
                114.476066,
                35.565201
              ],
              [
                114.477785,
                35.567217
              ],
              [
                114.484018,
                35.570152
              ],
              [
                114.486154,
                35.573033
              ],
              [
                114.485957,
                35.574312
              ],
              [
                114.485025,
                35.576327
              ],
              [
                114.482216,
                35.580937
              ],
              [
                114.481981,
                35.581844
              ],
              [
                114.482678,
                35.584425
              ],
              [
                114.484919,
                35.58512
              ],
              [
                114.486593,
                35.58515
              ],
              [
                114.490039,
                35.584474
              ],
              [
                114.497583,
                35.584145
              ],
              [
                114.499893,
                35.585114
              ],
              [
                114.500627,
                35.586508
              ],
              [
                114.500832,
                35.590867
              ],
              [
                114.500165,
                35.593424
              ],
              [
                114.498764,
                35.595476
              ],
              [
                114.496083,
                35.598166
              ],
              [
                114.495023,
                35.600048
              ],
              [
                114.495545,
                35.604345
              ],
              [
                114.497961,
                35.608034
              ],
              [
                114.500233,
                35.609166
              ],
              [
                114.502566,
                35.609294
              ],
              [
                114.52256,
                35.605173
              ],
              [
                114.526234,
                35.603554
              ],
              [
                114.528635,
                35.603408
              ],
              [
                114.53358,
                35.604065
              ],
              [
                114.538465,
                35.603584
              ],
              [
                114.541275,
                35.602501
              ],
              [
                114.543418,
                35.602629
              ],
              [
                114.549303,
                35.614772
              ],
              [
                114.550174,
                35.615441
              ],
              [
                114.552052,
                35.615904
              ],
              [
                114.554597,
                35.615703
              ],
              [
                114.558331,
                35.613475
              ],
              [
                114.56061,
                35.614346
              ],
              [
                114.564829,
                35.615009
              ],
              [
                114.567003,
                35.615934
              ],
              [
                114.57032,
                35.61661
              ],
              [
                114.574205,
                35.616403
              ],
              [
                114.576886,
                35.616805
              ],
              [
                114.578696,
                35.617778
              ],
              [
                114.580302,
                35.620328
              ],
              [
                114.585672,
                35.624619
              ],
              [
                114.5917,
                35.629043
              ],
              [
                114.607484,
                35.634221
              ],
              [
                114.612429,
                35.634617
              ],
              [
                114.61558,
                35.636564
              ],
              [
                114.616996,
                35.640057
              ],
              [
                114.617738,
                35.644894
              ],
              [
                114.618678,
                35.647443
              ],
              [
                114.620616,
                35.648921
              ],
              [
                114.622775,
                35.649828
              ],
              [
                114.634196,
                35.652225
              ],
              [
                114.645246,
                35.65481
              ],
              [
                114.647473,
                35.654883
              ],
              [
                114.652305,
                35.653812
              ],
              [
                114.660742,
                35.651124
              ],
              [
                114.666997,
                35.651105
              ],
              [
                114.671504,
                35.652754
              ],
              [
                114.67292,
                35.653971
              ],
              [
                114.674601,
                35.657225
              ],
              [
                114.675912,
                35.660522
              ],
              [
                114.676987,
                35.668393
              ],
              [
                114.677457,
                35.671033
              ],
              [
                114.678168,
                35.672815
              ],
              [
                114.680691,
                35.676841
              ],
              [
                114.682372,
                35.678057
              ],
              [
                114.683743,
                35.679553
              ],
              [
                114.685765,
                35.680666
              ],
              [
                114.68681,
                35.681876
              ],
              [
                114.687923,
                35.684157
              ],
              [
                114.689567,
                35.685574
              ],
              [
                114.693172,
                35.687355
              ],
              [
                114.696088,
                35.688201
              ],
              [
                114.700397,
                35.688444
              ],
              [
                114.703252,
                35.68828
              ],
              [
                114.704903,
                35.688687
              ],
              [
                114.705608,
                35.689508
              ],
              [
                114.706744,
                35.69287
              ],
              [
                114.707895,
                35.694281
              ],
              [
                114.710046,
                35.695224
              ],
              [
                114.714075,
                35.696105
              ],
              [
                114.718513,
                35.696245
              ],
              [
                114.721126,
                35.696044
              ],
              [
                114.724762,
                35.697729
              ],
              [
                114.727049,
                35.697881
              ],
              [
                114.731214,
                35.701912
              ],
              [
                114.735645,
                35.708666
              ],
              [
                114.741764,
                35.722902
              ],
              [
                114.747808,
                35.732371
              ],
              [
                114.751428,
                35.737671
              ],
              [
                114.752633,
                35.741535
              ],
              [
                114.753375,
                35.753014
              ],
              [
                114.752973,
                35.760535
              ],
              [
                114.751428,
                35.763354
              ],
              [
                114.74693,
                35.763907
              ],
              [
                114.741098,
                35.766555
              ],
              [
                114.739015,
                35.768918
              ],
              [
                114.733168,
                35.773146
              ],
              [
                114.727594,
                35.776025
              ],
              [
                114.722558,
                35.777295
              ],
              [
                114.719869,
                35.778364
              ],
              [
                114.716574,
                35.780982
              ],
              [
                114.711462,
                35.786077
              ],
              [
                114.709243,
                35.787414
              ],
              [
                114.70716,
                35.787547
              ],
              [
                114.703533,
                35.787201
              ],
              [
                114.695595,
                35.787322
              ],
              [
                114.688734,
                35.785865
              ],
              [
                114.678782,
                35.783162
              ],
              [
                114.675283,
                35.782081
              ],
              [
                114.673064,
                35.782148
              ],
              [
                114.670845,
                35.78281
              ],
              [
                114.668217,
                35.784353
              ],
              [
                114.663922,
                35.788573
              ],
              [
                114.658735,
                35.791452
              ],
              [
                114.655652,
                35.792181
              ],
              [
                114.650608,
                35.792278
              ],
              [
                114.636551,
                35.794069
              ],
              [
                114.627554,
                35.797482
              ],
              [
                114.621843,
                35.801101
              ],
              [
                114.6148,
                35.80687
              ],
              [
                114.61383,
                35.808078
              ],
              [
                114.612611,
                35.812037
              ],
              [
                114.611202,
                35.814574
              ],
              [
                114.611104,
                35.815479
              ],
              [
                114.612414,
                35.818363
              ],
              [
                114.612611,
                35.819977
              ],
              [
                114.611642,
                35.822187
              ],
              [
                114.606635,
                35.82345
              ],
              [
                114.597646,
                35.825162
              ],
              [
                114.596653,
                35.825963
              ],
              [
                114.59504,
                35.829253
              ],
              [
                114.593563,
                35.833987
              ],
              [
                114.587565,
                35.840069
              ],
              [
                114.585354,
                35.840002
              ],
              [
                114.583543,
                35.839468
              ],
              [
                114.575637,
                35.835778
              ],
              [
                114.573963,
                35.835584
              ],
              [
                114.570411,
                35.83599
              ],
              [
                114.569676,
                35.836664
              ],
              [
                114.570214,
                35.838473
              ],
              [
                114.571812,
                35.839547
              ],
              [
                114.572622,
                35.840888
              ],
              [
                114.572554,
                35.842497
              ],
              [
                114.571751,
                35.843571
              ],
              [
                114.570343,
                35.843977
              ],
              [
                114.566465,
                35.843716
              ],
              [
                114.563784,
                35.842175
              ],
              [
                114.55977,
                35.837957
              ],
              [
                114.555748,
                35.83071
              ],
              [
                114.554408,
                35.829241
              ],
              [
                114.552938,
                35.828203
              ],
              [
                114.54872,
                35.828209
              ],
              [
                114.545509,
                35.829089
              ],
              [
                114.540525,
                35.830734
              ],
              [
                114.520811,
                35.834783
              ],
              [
                114.515759,
                35.835547
              ],
              [
                114.509473,
                35.836707
              ],
              [
                114.503528,
                35.837065
              ],
              [
                114.495947,
                35.835742
              ],
              [
                114.493167,
                35.835414
              ],
              [
                114.486487,
                35.835857
              ],
              [
                114.482004,
                35.835729
              ],
              [
                114.4793,
                35.835268
              ],
              [
                114.478262,
                35.834801
              ],
              [
                114.475392,
                35.830582
              ],
              [
                114.473385,
                35.828622
              ],
              [
                114.47084,
                35.827487
              ],
              [
                114.468167,
                35.827292
              ],
              [
                114.457397,
                35.828931
              ],
              [
                114.453784,
                35.829204
              ],
              [
                114.451376,
                35.828737
              ],
              [
                114.450164,
                35.827468
              ],
              [
                114.447687,
                35.823614
              ],
              [
                114.446688,
                35.82019
              ],
              [
                114.445817,
                35.819182
              ],
              [
                114.443204,
                35.818381
              ],
              [
                114.438455,
                35.817452
              ],
              [
                114.435305,
                35.817725
              ],
              [
                114.431692,
                35.819067
              ],
              [
                114.429609,
                35.819206
              ],
              [
                114.427398,
                35.819747
              ],
              [
                114.425262,
                35.819814
              ],
              [
                114.42043,
                35.819279
              ],
              [
                114.416545,
                35.819146
              ],
              [
                114.412523,
                35.819686
              ],
              [
                114.40882,
                35.820676
              ],
              [
                114.38725,
                35.781783
              ],
              [
                114.385425,
                35.775752
              ],
              [
                114.383804,
                35.768068
              ],
              [
                114.384432,
                35.761726
              ],
              [
                114.384834,
                35.759132
              ],
              [
                114.387878,
                35.75144
              ],
              [
                114.389075,
                35.749496
              ],
              [
                114.39143,
                35.747733
              ],
              [
                114.394021,
                35.746555
              ],
              [
                114.394914,
                35.745254
              ],
              [
                114.394778,
                35.743267
              ],
              [
                114.393968,
                35.74156
              ],
              [
                114.391347,
                35.74035
              ],
              [
                114.38441,
                35.737847
              ],
              [
                114.379313,
                35.736291
              ],
              [
                114.355122,
                35.728427
              ],
              [
                114.360992,
                35.716435
              ],
              [
                114.367892,
                35.703632
              ],
              [
                114.36874,
                35.701036
              ],
              [
                114.369914,
                35.683165
              ],
              [
                114.369565,
                35.680715
              ],
              [
                114.364817,
                35.670601
              ],
              [
                114.362348,
                35.66582
              ],
              [
                114.362302,
                35.661459
              ],
              [
                114.362991,
                35.658673
              ],
              [
                114.362363,
                35.657651
              ],
              [
                114.359977,
                35.656483
              ],
              [
                114.358455,
                35.656106
              ],
              [
                114.35794,
                35.653861
              ],
              [
                114.359288,
                35.652346
              ],
              [
                114.355706,
                35.648647
              ],
              [
                114.354729,
                35.640921
              ],
              [
                114.348367,
                35.640531
              ],
              [
                114.336643,
                35.642223
              ],
              [
                114.333182,
                35.641487
              ],
              [
                114.33172,
                35.645313
              ],
              [
                114.328713,
                35.645885
              ],
              [
                114.325812,
                35.644553
              ],
              [
                114.323601,
                35.64437
              ],
              [
                114.322003,
                35.644918
              ],
              [
                114.321465,
                35.646402
              ],
              [
                114.320102,
                35.647753
              ],
              [
                114.319784,
                35.649736
              ],
              [
                114.317587,
                35.650454
              ],
              [
                114.318398,
                35.655212
              ],
              [
                114.321405,
                35.65464
              ],
              [
                114.321541,
                35.658095
              ],
              [
                114.316716,
                35.658551
              ],
              [
                114.312627,
                35.657499
              ],
              [
                114.296518,
                35.6561
              ],
              [
                114.296836,
                35.657712
              ],
              [
                114.295828,
                35.659093
              ],
              [
                114.291867,
                35.659245
              ],
              [
                114.290239,
                35.660224
              ],
              [
                114.288088,
                35.661009
              ],
              [
                114.285748,
                35.662219
              ],
              [
                114.284279,
                35.662365
              ],
              [
                114.283082,
                35.661495
              ],
              [
                114.280787,
                35.661848
              ],
              [
                114.284642,
                35.660686
              ],
              [
                114.293132,
                35.658782
              ],
              [
                114.294677,
                35.658113
              ],
              [
                114.295488,
                35.656282
              ],
              [
                114.292625,
                35.648021
              ],
              [
                114.292064,
                35.646074
              ],
              [
                114.291989,
                35.643628
              ],
              [
                114.293435,
                35.641566
              ],
              [
                114.299312,
                35.638682
              ],
              [
                114.301599,
                35.636071
              ],
              [
                114.302274,
                35.634294
              ],
              [
                114.301728,
                35.630899
              ],
              [
                114.30085,
                35.630078
              ],
              [
                114.295715,
                35.628556
              ],
              [
                114.29417,
                35.627583
              ],
              [
                114.293874,
                35.626779
              ],
              [
                114.294306,
                35.625167
              ],
              [
                114.298169,
                35.623189
              ],
              [
                114.298509,
                35.622416
              ],
              [
                114.298275,
                35.620049
              ],
              [
                114.297063,
                35.619178
              ],
              [
                114.291754,
                35.617858
              ],
              [
                114.290443,
                35.617285
              ],
              [
                114.289769,
                35.615539
              ],
              [
                114.289936,
                35.614467
              ],
              [
                114.292723,
                35.610073
              ],
              [
                114.29239,
                35.60863
              ],
              [
                114.288096,
                35.605885
              ],
              [
                114.28443,
                35.601149
              ],
              [
                114.283862,
                35.600139
              ],
              [
                114.281885,
                35.594867
              ],
              [
                114.281204,
                35.594063
              ],
              [
                114.276076,
                35.590989
              ],
              [
                114.275433,
                35.590179
              ],
              [
                114.27416,
                35.584669
              ],
              [
                114.272888,
                35.582355
              ],
              [
                114.271608,
                35.581046
              ],
              [
                114.263792,
                35.576406
              ],
              [
                114.26258,
                35.57475
              ],
              [
                114.262921,
                35.57246
              ],
              [
                114.268283,
                35.564038
              ],
              [
                114.268351,
                35.562357
              ],
              [
                114.26564,
                35.557369
              ],
              [
                114.265965,
                35.555627
              ],
              [
                114.26848,
                35.552843
              ],
              [
                114.269162,
                35.551095
              ],
              [
                114.269222,
                35.548379
              ],
              [
                114.265837,
                35.538723
              ],
              [
                114.264928,
                35.536371
              ],
              [
                114.261974,
                35.533185
              ],
              [
                114.260399,
                35.530596
              ],
              [
                114.260732,
                35.527708
              ],
              [
                114.261467,
                35.526398
              ],
              [
                114.265867,
                35.522857
              ],
              [
                114.266534,
                35.521651
              ],
              [
                114.266836,
                35.51836
              ],
              [
                114.267306,
                35.517556
              ],
              [
                114.269048,
                35.517221
              ],
              [
                114.273948,
                35.519201
              ],
              [
                114.276334,
                35.518702
              ],
              [
                114.278083,
                35.513717
              ],
              [
                114.279553,
                35.51298
              ],
              [
                114.281135,
                35.513248
              ],
              [
                114.284362,
                35.514662
              ],
              [
                114.287709,
                35.514601
              ],
              [
                114.290103,
                35.512522
              ],
              [
                114.290898,
                35.51081
              ],
              [
                114.291133,
                35.509195
              ],
              [
                114.289891,
                35.50179
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "adcode": 410622,
        "name": "淇县",
        "center": [
          114.200379,
          35.609478
        ],
        "centroid": [
          114.161841,
          35.661286
        ],
        "childrenNum": 0,
        "level": "district",
        "parent": {
          "adcode": 410600
        },
        "subFeatureIndex": 4,
        "acroutes": [
          100000,
          410000,
          410600
        ]
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                114.078132,
                35.803008
              ],
              [
                114.078753,
                35.80118
              ],
              [
                114.078275,
                35.799237
              ],
              [
                114.076056,
                35.795405
              ],
              [
                114.073769,
                35.790298
              ],
              [
                114.073375,
                35.788422
              ],
              [
                114.072974,
                35.783721
              ],
              [
                114.071353,
                35.779694
              ],
              [
                114.069748,
                35.777945
              ],
              [
                114.067051,
                35.77693
              ],
              [
                114.066582,
                35.775388
              ],
              [
                114.06746,
                35.772703
              ],
              [
                114.069475,
                35.768378
              ],
              [
                114.069475,
                35.764885
              ],
              [
                114.06874,
                35.761592
              ],
              [
                114.067263,
                35.759107
              ],
              [
                114.060523,
                35.754812
              ],
              [
                114.058811,
                35.751239
              ],
              [
                114.05538,
                35.749204
              ],
              [
                114.051488,
                35.748305
              ],
              [
                114.047799,
                35.747891
              ],
              [
                114.04299,
                35.74808
              ],
              [
                114.042013,
                35.747442
              ],
              [
                114.036802,
                35.740666
              ],
              [
                114.032834,
                35.737026
              ],
              [
                114.0296,
                35.73541
              ],
              [
                114.026305,
                35.734322
              ],
              [
                114.024086,
                35.732906
              ],
              [
                114.021057,
                35.729004
              ],
              [
                114.017558,
                35.725911
              ],
              [
                114.014861,
                35.72523
              ],
              [
                114.002478,
                35.724786
              ],
              [
                114.001199,
                35.724178
              ],
              [
                113.999517,
                35.722701
              ],
              [
                113.998313,
                35.719808
              ],
              [
                113.996018,
                35.704811
              ],
              [
                113.998305,
                35.70452
              ],
              [
                114.0006,
                35.703115
              ],
              [
                114.01009,
                35.698495
              ],
              [
                114.014998,
                35.697133
              ],
              [
                114.019777,
                35.695607
              ],
              [
                114.021655,
                35.694062
              ],
              [
                114.022533,
                35.692658
              ],
              [
                114.023003,
                35.689301
              ],
              [
                114.023041,
                35.686917
              ],
              [
                114.024139,
                35.684972
              ],
              [
                114.026805,
                35.683774
              ],
              [
                114.030902,
                35.683518
              ],
              [
                114.035181,
                35.683007
              ],
              [
                114.039824,
                35.681542
              ],
              [
                114.044997,
                35.678872
              ],
              [
                114.050208,
                35.675661
              ],
              [
                114.051079,
                35.674688
              ],
              [
                114.051889,
                35.672006
              ],
              [
                114.057509,
                35.660656
              ],
              [
                114.059016,
                35.657365
              ],
              [
                114.059546,
                35.653709
              ],
              [
                114.06103,
                35.647534
              ],
              [
                114.064317,
                35.637787
              ],
              [
                114.064529,
                35.636077
              ],
              [
                114.063757,
                35.632518
              ],
              [
                114.058546,
                35.626737
              ],
              [
                114.057668,
                35.624199
              ],
              [
                114.057865,
                35.621375
              ],
              [
                114.059811,
                35.616951
              ],
              [
                114.060349,
                35.614869
              ],
              [
                114.060281,
                35.611376
              ],
              [
                114.056259,
                35.598246
              ],
              [
                114.055986,
                35.596431
              ],
              [
                114.056183,
                35.59455
              ],
              [
                114.057796,
                35.591665
              ],
              [
                114.060689,
                35.588383
              ],
              [
                114.072777,
                35.57964
              ],
              [
                114.075738,
                35.576017
              ],
              [
                114.077079,
                35.573063
              ],
              [
                114.077352,
                35.570049
              ],
              [
                114.080086,
                35.567327
              ],
              [
                114.085599,
                35.564105
              ],
              [
                114.088735,
                35.562771
              ],
              [
                114.089591,
                35.561383
              ],
              [
                114.092923,
                35.560847
              ],
              [
                114.097755,
                35.557052
              ],
              [
                114.098944,
                35.556333
              ],
              [
                114.102564,
                35.554927
              ],
              [
                114.104874,
                35.554257
              ],
              [
                114.111562,
                35.553641
              ],
              [
                114.116182,
                35.552764
              ],
              [
                114.120135,
                35.55115
              ],
              [
                114.125088,
                35.547453
              ],
              [
                114.134267,
                35.541605
              ],
              [
                114.13916,
                35.538339
              ],
              [
                114.146681,
                35.5343
              ],
              [
                114.153474,
                35.530882
              ],
              [
                114.157799,
                35.52903
              ],
              [
                114.164312,
                35.527537
              ],
              [
                114.168167,
                35.526294
              ],
              [
                114.171477,
                35.523966
              ],
              [
                114.174317,
                35.523893
              ],
              [
                114.176521,
                35.524381
              ],
              [
                114.180141,
                35.524271
              ],
              [
                114.182042,
                35.523997
              ],
              [
                114.187692,
                35.522212
              ],
              [
                114.191979,
                35.521846
              ],
              [
                114.193592,
                35.522352
              ],
              [
                114.197235,
                35.524326
              ],
              [
                114.19928,
                35.524722
              ],
              [
                114.202188,
                35.52485
              ],
              [
                114.204589,
                35.524448
              ],
              [
                114.209913,
                35.522425
              ],
              [
                114.212791,
                35.520353
              ],
              [
                114.214533,
                35.518306
              ],
              [
                114.215601,
                35.517562
              ],
              [
                114.218517,
                35.517221
              ],
              [
                114.220864,
                35.517355
              ],
              [
                114.224878,
                35.516514
              ],
              [
                114.237133,
                35.512352
              ],
              [
                114.244873,
                35.509597
              ],
              [
                114.259861,
                35.504941
              ],
              [
                114.266602,
                35.503198
              ],
              [
                114.273221,
                35.501699
              ],
              [
                114.276334,
                35.501302
              ],
              [
                114.28162,
                35.501168
              ],
              [
                114.289891,
                35.50179
              ],
              [
                114.291133,
                35.509195
              ],
              [
                114.290898,
                35.51081
              ],
              [
                114.290103,
                35.512522
              ],
              [
                114.287709,
                35.514601
              ],
              [
                114.284362,
                35.514662
              ],
              [
                114.281135,
                35.513248
              ],
              [
                114.279553,
                35.51298
              ],
              [
                114.278083,
                35.513717
              ],
              [
                114.276334,
                35.518702
              ],
              [
                114.273948,
                35.519201
              ],
              [
                114.269048,
                35.517221
              ],
              [
                114.267306,
                35.517556
              ],
              [
                114.266836,
                35.51836
              ],
              [
                114.266534,
                35.521651
              ],
              [
                114.265867,
                35.522857
              ],
              [
                114.261467,
                35.526398
              ],
              [
                114.260732,
                35.527708
              ],
              [
                114.260399,
                35.530596
              ],
              [
                114.261974,
                35.533185
              ],
              [
                114.264928,
                35.536371
              ],
              [
                114.265837,
                35.538723
              ],
              [
                114.269222,
                35.548379
              ],
              [
                114.269162,
                35.551095
              ],
              [
                114.26848,
                35.552843
              ],
              [
                114.265965,
                35.555627
              ],
              [
                114.26564,
                35.557369
              ],
              [
                114.268351,
                35.562357
              ],
              [
                114.268283,
                35.564038
              ],
              [
                114.262921,
                35.57246
              ],
              [
                114.26258,
                35.57475
              ],
              [
                114.263792,
                35.576406
              ],
              [
                114.271608,
                35.581046
              ],
              [
                114.272888,
                35.582355
              ],
              [
                114.27416,
                35.584669
              ],
              [
                114.275433,
                35.590179
              ],
              [
                114.276076,
                35.590989
              ],
              [
                114.281204,
                35.594063
              ],
              [
                114.281885,
                35.594867
              ],
              [
                114.283862,
                35.600139
              ],
              [
                114.28443,
                35.601149
              ],
              [
                114.288096,
                35.605885
              ],
              [
                114.29239,
                35.60863
              ],
              [
                114.292723,
                35.610073
              ],
              [
                114.289936,
                35.614467
              ],
              [
                114.289769,
                35.615539
              ],
              [
                114.290443,
                35.617285
              ],
              [
                114.291754,
                35.617858
              ],
              [
                114.297063,
                35.619178
              ],
              [
                114.298275,
                35.620049
              ],
              [
                114.298509,
                35.622416
              ],
              [
                114.298169,
                35.623189
              ],
              [
                114.294306,
                35.625167
              ],
              [
                114.293874,
                35.626779
              ],
              [
                114.29417,
                35.627583
              ],
              [
                114.295715,
                35.628556
              ],
              [
                114.30085,
                35.630078
              ],
              [
                114.301728,
                35.630899
              ],
              [
                114.302274,
                35.634294
              ],
              [
                114.301599,
                35.636071
              ],
              [
                114.299312,
                35.638682
              ],
              [
                114.293435,
                35.641566
              ],
              [
                114.291989,
                35.643628
              ],
              [
                114.292064,
                35.646074
              ],
              [
                114.292625,
                35.648021
              ],
              [
                114.295488,
                35.656282
              ],
              [
                114.294677,
                35.658113
              ],
              [
                114.293132,
                35.658782
              ],
              [
                114.284642,
                35.660686
              ],
              [
                114.280787,
                35.661848
              ],
              [
                114.279234,
                35.662523
              ],
              [
                114.278144,
                35.664877
              ],
              [
                114.277652,
                35.67012
              ],
              [
                114.276478,
                35.672778
              ],
              [
                114.273691,
                35.677194
              ],
              [
                114.267738,
                35.680508
              ],
              [
                114.263716,
                35.682259
              ],
              [
                114.260596,
                35.682782
              ],
              [
                114.257324,
                35.684284
              ],
              [
                114.255415,
                35.685586
              ],
              [
                114.254438,
                35.686753
              ],
              [
                114.254105,
                35.68817
              ],
              [
                114.254294,
                35.691581
              ],
              [
                114.254825,
                35.695631
              ],
              [
                114.255256,
                35.697352
              ],
              [
                114.256907,
                35.701565
              ],
              [
                114.259217,
                35.703054
              ],
              [
                114.262345,
                35.703754
              ],
              [
                114.264171,
                35.703614
              ],
              [
                114.26589,
                35.704605
              ],
              [
                114.267261,
                35.706538
              ],
              [
                114.267904,
                35.708757
              ],
              [
                114.267397,
                35.711426
              ],
              [
                114.26333,
                35.710386
              ],
              [
                114.259051,
                35.710891
              ],
              [
                114.258536,
                35.709967
              ],
              [
                114.257619,
                35.711006
              ],
              [
                114.257809,
                35.713341
              ],
              [
                114.254582,
                35.713979
              ],
              [
                114.257354,
                35.720848
              ],
              [
                114.260073,
                35.721948
              ],
              [
                114.260709,
                35.721145
              ],
              [
                114.262057,
                35.721346
              ],
              [
                114.263368,
                35.72402
              ],
              [
                114.26358,
                35.725911
              ],
              [
                114.259785,
                35.726634
              ],
              [
                114.257892,
                35.722398
              ],
              [
                114.253484,
                35.722203
              ],
              [
                114.253583,
                35.724543
              ],
              [
                114.249137,
                35.725753
              ],
              [
                114.250288,
                35.732906
              ],
              [
                114.249432,
                35.733003
              ],
              [
                114.248508,
                35.736072
              ],
              [
                114.244684,
                35.736182
              ],
              [
                114.244782,
                35.737233
              ],
              [
                114.243813,
                35.73823
              ],
              [
                114.243601,
                35.740113
              ],
              [
                114.244441,
                35.741882
              ],
              [
                114.245827,
                35.740752
              ],
              [
                114.247031,
                35.742125
              ],
              [
                114.246478,
                35.740344
              ],
              [
                114.248266,
                35.739591
              ],
              [
                114.249175,
                35.738473
              ],
              [
                114.251114,
                35.74139
              ],
              [
                114.253961,
                35.740922
              ],
              [
                114.25437,
                35.741614
              ],
              [
                114.252303,
                35.742447
              ],
              [
                114.255249,
                35.7419
              ],
              [
                114.255287,
                35.742994
              ],
              [
                114.256377,
                35.742994
              ],
              [
                114.256218,
                35.744282
              ],
              [
                114.256673,
                35.749356
              ],
              [
                114.255294,
                35.75113
              ],
              [
                114.254075,
                35.751768
              ],
              [
                114.250152,
                35.753099
              ],
              [
                114.24794,
                35.756307
              ],
              [
                114.244524,
                35.757042
              ],
              [
                114.243654,
                35.757479
              ],
              [
                114.240935,
                35.759964
              ],
              [
                114.238693,
                35.760438
              ],
              [
                114.237254,
                35.760067
              ],
              [
                114.233066,
                35.756161
              ],
              [
                114.230119,
                35.754083
              ],
              [
                114.228203,
                35.753718
              ],
              [
                114.225462,
                35.754119
              ],
              [
                114.223591,
                35.755031
              ],
              [
                114.222447,
                35.756307
              ],
              [
                114.22091,
                35.760505
              ],
              [
                114.22088,
                35.762582
              ],
              [
                114.222924,
                35.769817
              ],
              [
                114.222818,
                35.772436
              ],
              [
                114.221978,
                35.773371
              ],
              [
                114.217403,
                35.776402
              ],
              [
                114.216161,
                35.777611
              ],
              [
                114.214427,
                35.780933
              ],
              [
                114.210095,
                35.791136
              ],
              [
                114.208224,
                35.79461
              ],
              [
                114.205922,
                35.795922
              ],
              [
                114.200325,
                35.798077
              ],
              [
                114.19856,
                35.798314
              ],
              [
                114.196614,
                35.798083
              ],
              [
                114.193743,
                35.796511
              ],
              [
                114.190297,
                35.794337
              ],
              [
                114.188389,
                35.793717
              ],
              [
                114.184943,
                35.793723
              ],
              [
                114.183004,
                35.794027
              ],
              [
                114.178248,
                35.796219
              ],
              [
                114.171901,
                35.798345
              ],
              [
                114.165547,
                35.800069
              ],
              [
                114.162631,
                35.800294
              ],
              [
                114.159321,
                35.800197
              ],
              [
                114.157746,
                35.799899
              ],
              [
                114.154065,
                35.797689
              ],
              [
                114.151225,
                35.797428
              ],
              [
                114.148044,
                35.798806
              ],
              [
                114.146203,
                35.799012
              ],
              [
                114.143325,
                35.79883
              ],
              [
                114.139842,
                35.798266
              ],
              [
                114.137062,
                35.798502
              ],
              [
                114.135525,
                35.799012
              ],
              [
                114.133048,
                35.801563
              ],
              [
                114.128792,
                35.80466
              ],
              [
                114.12705,
                35.805042
              ],
              [
                114.123839,
                35.804575
              ],
              [
                114.121665,
                35.80367
              ],
              [
                114.12012,
                35.803639
              ],
              [
                114.115629,
                35.806293
              ],
              [
                114.113955,
                35.8067
              ],
              [
                114.11013,
                35.806092
              ],
              [
                114.107123,
                35.805892
              ],
              [
                114.104503,
                35.806092
              ],
              [
                114.100277,
                35.807289
              ],
              [
                114.095718,
                35.807349
              ],
              [
                114.09284,
                35.807082
              ],
              [
                114.08881,
                35.804866
              ],
              [
                114.085319,
                35.803785
              ],
              [
                114.080487,
                35.803718
              ],
              [
                114.078132,
                35.803008
              ]
            ]
          ]
        ]
      }
    }
  ]
}